const data = [
  {
    image: require("../src/Images/website.png"),
    caption: "Stock Trading Platform [Web]",
    description: "Full-stack stock trading platform with real-time market data, portfolio tracking, and interactive charting built with Angular and Node.js on GCP.",
    tech: ["Angular", "Node.js", "GCP", "APIs"],
    url: "https://youtu.be/hBM3-R4Q3PY"
  },
  {
    image: require("../src/Images/tradingapp.png"),
    caption: "Stock Trading Platform [Mobile]",
    description: "Native iOS companion app for the stock trading platform with SwiftUI, real-time portfolio updates, and watchlist management.",
    tech: ["SwiftUI", "iOS", "REST API"],
    url: "https://youtu.be/rLVHoRCVc0s"
  },
  {
    image: require("../src/Images/caption.jpg"),
    caption: "Environmental Caption Generation",
    description: "ML-powered system that generates descriptive captions of environments for visually impaired users using computer vision and NLP.",
    tech: ["Python", "TensorFlow", "NLP", "CV"],
    url: "https://github.com/devkansara/Environmental-Caption-Generation-for-Visually-Disabled"
  },
  {
    image: require("../src/Images/prnpm.png"),
    caption: "IoT Pattern Matching & Behavior Tagging",
    description: "Research project on pattern recognition and behavior tagging in IoT data streams using machine learning algorithms.",
    tech: ["Python", "ML", "IoT", "Research"],
    url: "https://github.com/devkansara/Major-Project"
  },
  {
    image: require("../src/Images/crazycolors.png"),
    caption: "Crazy Colors",
    description: "An interactive color-matching game built in Unity with WebGL deployment, featuring dynamic difficulty and smooth animations.",
    tech: ["Unity", "C#", "WebGL"],
    url: "https://devkansara.github.io/Crazy-Colors-WebGL/"
  },
  {
    image: require("../src/Images/vlabs.png"),
    caption: "Virtual Lab: Networking Simulators",
    description: "Interactive web-based networking simulators for educational use: parity check, hamming code, and protocol demonstrations.",
    tech: ["Django", "JavaScript", "Networking"],
    url: "https://github.com/devkansara/Virtual-Lab-Networking-Simulators"
  },
  {
    image: require("../src/Images/covid.png"),
    caption: "Covid Detection via Chest X-Ray",
    description: "Deep learning model to detect COVID-19 from chest X-ray images using transfer learning and convolutional neural networks.",
    tech: ["Python", "TensorFlow", "CNN", "ML"],
    url: "https://github.com/devkansara/Covid-Detection-Using-Chest-X-Ray"
  },
  {
    image: require("../src/Images/car.png"),
    caption: "Carrent",
    description: "Web-based car rental management system with user authentication, booking management, and admin dashboard.",
    tech: ["React", "Node.js", "MongoDB"],
    url: "https://github.com/devkansara/Carrent"
  },
  {
    image: require("../src/Images/imagegall.png"),
    caption: "Static Image Gallery",
    description: "A clean, responsive image gallery application built with Java featuring grid layouts and image preview functionality.",
    tech: ["Java", "UI/UX"],
    url: "https://github.com/devkansara/Static-Image-Gallery-using-Java"
  },
];

export default data;
